<template>
  <transition name="a-transtion-slide">
    <div class="m-the-header-upgrade">
      <p>
        {{ $t('mTheHeaderAcademyDataRequired.academy.firstText') }}
        <router-link
          :to="`/${this.$t('rPaths.academy')}/${this.$t('mEditionMenu.academy.data.subject')}`"
          class="text-link-hover-academy"
        >
          <i class="far fa-link font-size-small"></i>
          {{ $t('mTheHeaderAcademyDataRequired.academy.linkText') }}
        </router-link>
      </p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MoleculeTheHeaderAcademyDataRequired'
}
</script>
